module.exports = __webpack_public_path__ + "static/media/thumbnail.5c80c992.webp";